import { BoxProps } from '@jfs/ui-new'

export enum filterTypes {
  applicationStatus = 'applicationStatus',
  level = 'level',
  status = 'status',
  search = 'search',
  auditType = 'auditType',
}

export interface FilterProps {
  onPress: () => void
  apply: () => void
  selectedFilteredData: any
  updateFilters: (mode: filterTypes, value: string) => void
  checkSelected: (mode: filterTypes, value: string) => boolean
  filterData: any
  selectedValue: any
  mode: filterTypes
  restoreDefaults?: () => void
}

export interface FilterDataprops {
  min: string
  max: string
  applicationStatus: Array<string>
  paymentMode: Array<string>
}

export interface FilterItemProps {
  mode: filterTypes
  updateFilters: (mode: filterTypes, value: string) => void
  checkSelected: (mode: filterTypes, value: string) => boolean
  header: string
  filterData: any
  hide?: boolean
  selectedValue?: string
}

export interface CLFilterProps {
  filterData: any
  updateFilters: (mode: filterTypes, value: string) => void
  style: BoxProps
  selectedValue?: string
  mode: filterTypes
}
